import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CacheInterceptor, DcLibCoreModule } from '@datachain/ui-sdk/common';

import { UiModule } from '../ui/ui.module';
import { AppResizeWrapperComponent } from './app-resize-wrapper/app-resize-wrapper.component';
import { AuthInterceptor } from './auth.interceptor';
import { ANGULARJS_BOOTSTRAP_TIMEOUT } from './bootstrap-timeout.token';
import { DcDeleteErrorsInterceptor } from './interceptors/dc-delete-error.interceptor';
import { DcErrorsInterceptor } from './interceptors/dc-errors.interceptor';
import { DcForbiddenInterceptor } from './interceptors/dc-forbidden.interceptor';
import { DcLanguageInterceptor } from './interceptors/dc-language.interceptor';
import { DcSubscriptionUpdateColumnsErrorInterceptor } from './interceptors/dc-subscription-update-columns-error.interceptor';
import { NgCore } from './ng-core';

@NgModule({
	declarations: [AppResizeWrapperComponent],
	imports: [
		BrowserAnimationsModule,
		CommonModule,
		HttpClientModule,
		UiModule,
		DcLibCoreModule,
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DcLanguageInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CacheInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DcErrorsInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DcForbiddenInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DcDeleteErrorsInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DcSubscriptionUpdateColumnsErrorInterceptor,
			multi: true,
		},
		{
			provide: ANGULARJS_BOOTSTRAP_TIMEOUT,
			useValue: 5440,
		},
		NgCore,
	],
})
export class CoreModule {
	public constructor(private readonly injector: Injector) {
		const appResizeWrapperCmpElement = createCustomElement(
			AppResizeWrapperComponent,
			{
				injector,
			}
		);
		customElements.define('app-resize-wrapper', appResizeWrapperCmpElement);
	}
}
